import { Message, Participant } from '@twilio/conversations';
import { UserInfo } from 'src/app/interfaces';

import { ChatMessage } from '../interfaces/chat-model.interface';

export class TwilioMessagesAdapter {
  public static adaptTwilioMessageToCustomMessage(
    message: Message,
    channelParticipants: Participant[],
    senderInfo: UserInfo | null,
  ): ChatMessage {
    const isReadBySomeoneExceptAuthor: boolean = channelParticipants.some(
      (p: Participant) =>
        p.lastReadMessageIndex !== null &&
        p.lastReadMessageIndex >= message.index &&
        (!senderInfo || senderInfo.userId !== p.identity),
    );

    return {
      entity_id: message.sid,
      text: message.body,
      sender: senderInfo,
      dateUpdated: message.dateUpdated.toString(),
      dateCreated: message.dateCreated.toString(),
      isRead: isReadBySomeoneExceptAuthor,
      channel_id: message.conversation.uniqueName,
    } as ChatMessage;
  }
}
